import styled from '@emotion/styled';
import { StyledProps as Props, Theme } from './Column.types';
import facepaint from 'facepaint';

const media = (theme: Theme): string[] => theme.screenSizes.map((size) => `@media(min-width: ${size}px)`);
const mediaWithXs = (theme: Theme): string[] => [`@media(max-width: ${theme.screenSizes[0]}px)`, ...media(theme)];
const gridColumns = (props): string[] =>
  props.theme.grid.column.availableSizes.map((size) => (props[size] ? `span ${props[size]}` : null));

export default styled.div<Props, Theme>`
  ${(props) =>
    facepaint(mediaWithXs(props.theme))({
      gridColumn: [props.span ? `span ${props.span}` : null, ...gridColumns(props)],
    })}
`;
